import Bio from "./bio"

export default Bio